const checkoutQueryString = (email, address) => {

	const addressKeysMapping = {
		firstName: "first_name",
		lastName: "last_name"
	};

	const queryParams = [`checkout[email]=${encodeURIComponent(email)}`];

	Object.keys(address ?? {}).forEach((key) => {
		const newKey = addressKeysMapping[key] || key;
		const value = address[key];

		if (value) {
			queryParams.push(
				`${encodeURIComponent(`checkout[shipping_address][${newKey}]`)}=${encodeURIComponent(value)}`
			);
		}
	});

	return queryParams.filter(param => param).join("&");
};

export default checkoutQueryString;